<app-device-form
  [device]="null"
  action="{{ 'new' | translate }}"
  (close)="closeForm($event)">
</app-device-form>
